import React, { FunctionComponent } from 'react'

import {
  FormField as BRFormField,
  ErrorMessage,
  Fieldset,
  InfoIcon,
} from '@vwfs-bronson/bronson-react'

import { Field } from 'formik'
import get from 'lodash/get'

interface Props {
  render: Function
  name: string
  labelElement?: string
  labelText?: string
  hint?: string
  infoIcon?: string
  notion?: boolean
  type?: string
  className?: string
  testId?: string
  handleBlur?: Function;
  id?: string;
  ariaLabelInfoIcon?: string;
  showErrorMessageFormField?: boolean;
}

export const FormField: FunctionComponent<Props> = ({
  render,
  name,
  labelText,
  hint,
  infoIcon,
  type,
  className,
  testId,
  handleBlur,
  ariaLabelInfoIcon,
  showErrorMessageFormField = true,
}: any) => {
  return (
    <Fieldset.Row>
      <Field name={name}>
        {({ field, form }) => {
          return (
            <BRFormField
              onBlur={e => handleBlur && handleBlur(e)}
              testId={testId}
              labelForId={name}
              className={className}
              noFloatingLabel
              labelText={
                labelText
                  ? ((
                    <>
                      {labelText}
                      {infoIcon && (
                        <InfoIcon icon="semantic-info" aria-label={ariaLabelInfoIcon}>{infoIcon}</InfoIcon>
                      )}
                    </>
                  ) as unknown as string)
                  : undefined
              }
              type={type}
              errorMessage={
                get(form.errors, name) && get(form.touched, name) && showErrorMessageFormField ? (
                  <ErrorMessage id={name}>
                    {get(form.touched, name) && get(form.errors, name)}
                  </ErrorMessage>
                ) : (
                  ''
                )
              }
              hint={hint}
            >
              {render({
                name,
                error: !!(get(form.touched, name)
                  ? get(form.errors, name)
                  : undefined),
                ...field,
              })}
            </BRFormField>
          )
        }}
      </Field>
    </Fieldset.Row>
  )
}
